import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import NewsTelop from "../components/NewsTelop";
import SkillSheetEditStepper from "../components/skill_sheet_basic/pages/edit/SkillSheetEditStepper";
import SkillSheetCreateStepper from "../components/skill_sheet_basic/pages/create/SkillSheetCreateStepper";
import SkillSheetMainCreateStepper from "../components/skill_sheet_main/pages/create/SkillSheetMainCreateStepper";
import SkillSheetMainEditStepper from "../components/skill_sheet_main/pages/edit/SkillSheetMainEditStepper";
import UserContractRequestPage from "../components/user_contract_request/pages/UserContractRequestPage";
import ProjectRequestEdit from "../components/user_contract_request/pages/ProjectRequestEdit";
import UserJobRequestPage from "../components/user_job_request/pages/UserJobRequestPage";
import JobRequestEdit from "../components/user_job_request/pages/JobRequestEdit";
import AppRouter from "../AppRouter";
import "react-toastify/dist/ReactToastify.css";
import ToastProvider from "../components/shared/ToastProvider";
import CompanyUsers from "../components/company/users/CompanyUsers";
import Unread from "../components/unread_projects_jobs/Unread";

document.addEventListener("DOMContentLoaded", async () => {
  // ======== NewsTelop ========
  const reactNewsTelopContainers =
    document.querySelectorAll(".react-news-telop");
  reactNewsTelopContainers.forEach((container) => {
    if (container) {
      const dataset = container.dataset;
      const props = {
        newsContent: dataset.newsContent,
      };
      const reactNewsTelopRoot = createRoot(container);
      reactNewsTelopRoot.render(
        <React.StrictMode>
          <NewsTelop {...props} />
        </React.StrictMode>
      );
    }
  });

  // ======== SkillSheetEditStepper (編集用) ========
  const skillSheetEditStepperContainers = document.querySelectorAll(
    ".react-skill-sheet-edit-stepper"
  );
  skillSheetEditStepperContainers.forEach((container) => {
    if (container) {
      const dataset = container.dataset;
      const skillSheetTemplate = dataset.skillSheetTemplate
        ? JSON.parse(dataset.skillSheetTemplate)
        : {};

      const props = {
        skillSheetTemplate,
        role: dataset.role,
        csrfToken: dataset.csrfToken,
        formAction: dataset.formAction,
      };

      const skillSheetEditStepperRoot = createRoot(container);
      skillSheetEditStepperRoot.render(
        <React.StrictMode>
          <SkillSheetEditStepper {...props} />
        </React.StrictMode>
      );
    }
  });

  // ======== SkillSheetCreateStepper (新規登録用) ========
  const skillSheetCreateStepperContainers = document.querySelectorAll(
    ".react-skill-sheet-create-stepper"
  );
  skillSheetCreateStepperContainers.forEach((container) => {
    if (container) {
      const dataset = container.dataset;
      const skillSheetTemplate = dataset.skillSheetTemplate
        ? JSON.parse(dataset.skillSheetTemplate)
        : {};

      const props = {
        skillSheetTemplate,
        role: dataset.role,
        csrfToken: dataset.csrfToken,
        formAction: dataset.formAction,
      };

      const skillSheetCreateStepperRoot = createRoot(container);
      skillSheetCreateStepperRoot.render(
        <React.StrictMode>
          <SkillSheetCreateStepper {...props} />
        </React.StrictMode>
      );
    }
  });

  // ======== SkillSheetMainCreateStepper (プロジェクト追加用) ========
  const skillSheetMainCreateStepperContainers = document.querySelectorAll(
    ".react-skill-sheet-main-create-stepper"
  );
  skillSheetMainCreateStepperContainers.forEach((container) => {
    if (container) {
      const dataset = container.dataset;

      const props = {
        csrfToken: dataset.csrfToken,
        formAction: dataset.formAction,
      };

      const skillSheetMainCreateStepperRoot = createRoot(container);
      skillSheetMainCreateStepperRoot.render(
        <React.StrictMode>
          <SkillSheetMainCreateStepper {...props} />
        </React.StrictMode>
      );
    }
  });

  // ======== SkillSheetMainEditStepper (プロジェクト編集用) ========
  const skillSheetMainEditStepperContainers = document.querySelectorAll(
    ".react-skill-sheet-main-edit-stepper"
  );
  skillSheetMainEditStepperContainers.forEach((container) => {
    if (container) {
      const dataset = container.dataset;
      const workHistory = dataset.workHistory
        ? JSON.parse(dataset.workHistory)
        : null;

      const props = {
        csrfToken: dataset.csrfToken,
        formAction: dataset.formAction,
        workHistory: workHistory,
      };

      const skillSheetMainEditStepperRoot = createRoot(container);
      skillSheetMainEditStepperRoot.render(
        <React.StrictMode>
          <SkillSheetMainEditStepper {...props} />
        </React.StrictMode>
      );
    }
  });

  // ======== UserContractRequestPage (プロジェクト募集要項閲覧)  ========
  const userContractRequestContainers = document.querySelectorAll(
    ".react-user-contract-request"
  );
  userContractRequestContainers.forEach((container) => {
    if (container) {
      const dataset = container.dataset;
      const userContractRequestInfo = dataset.userContractRequestInfo
        ? JSON.parse(dataset.userContractRequestInfo)
        : {};
      const userContractRequest = dataset.userContractRequest
        ? JSON.parse(dataset.userContractRequest)
        : {};
      const flashMessage = dataset.flashMessage
        ? JSON.parse(dataset.flashMessage)
        : null;
      const priorities = dataset.priorities
        ? JSON.parse(dataset.priorities)
        : [];
      const jobRecruitingFlag = dataset.jobRecruitingFlag
        ? JSON.parse(dataset.jobRecruitingFlag)
        : false;

      const props = {
        userContractRequestInfo,
        userContractRequest,
        flashMessage,
        priorities,
        jobRecruitingFlag,
      };

      const userContractRequestRoot = createRoot(container);
      userContractRequestRoot.render(
        <ToastProvider>
          <React.StrictMode>
            <UserContractRequestPage {...props} />
          </React.StrictMode>
        </ToastProvider>
      );
    }
  });

  // ======== ProjectRequestEdit(プロジェクト募集要項編集)  ========
  const projectRequestEditContainers = document.querySelectorAll(
    ".react-user-contract-request-edit"
  );
  projectRequestEditContainers.forEach((container) => {
    if (container) {
      const dataset = container.dataset;
      const userContractRequest = dataset.userContractRequest
        ? JSON.parse(dataset.userContractRequest)
        : {};
      const flashMessage = dataset.flashMessage
        ? JSON.parse(dataset.flashMessage)
        : null;
      const priorities = dataset.priorities
        ? JSON.parse(dataset.priorities)
        : [];

      const props = {
        userContractRequest,
        flashMessage,
        priorities,
        csrfToken: dataset.csrfToken,
        formAction: dataset.formAction,
      };

      const root = createRoot(container);
      root.render(
        <React.StrictMode>
          <ProjectRequestEdit {...props} />
        </React.StrictMode>
      );
    }
  });

  // ======== UserJobRequestPage (求人募集要項閲覧)  ========
  const userJobRequestContainers = document.querySelectorAll(
    ".react-user-job-request"
  );
  userJobRequestContainers.forEach((container) => {
    if (container) {
      const dataset = container.dataset;
      const userJobRequestInfo = dataset.userJobRequestInfo
        ? JSON.parse(dataset.userJobRequestInfo)
        : {};
      const userJobRequest = dataset.userJobRequest
        ? JSON.parse(dataset.userJobRequest)
        : {};
      const flashMessage = dataset.flashMessage
        ? JSON.parse(dataset.flashMessage)
        : null;
      const prefectures = dataset.prefectures
        ? JSON.parse(dataset.prefectures)
        : [];
      const contractRecruitingFlag = dataset.contractRecruitingFlag
        ? JSON.parse(dataset.contractRecruitingFlag)
        : false;

      const props = {
        userJobRequestInfo,
        userJobRequest,
        flashMessage,
        csrfToken: dataset.csrfToken,
        formAction: dataset.formAction,
        prefectures,
        contractRecruitingFlag,
      };

      const userJobRequestRoot = createRoot(container);
      userJobRequestRoot.render(
        <ToastProvider>
          <React.StrictMode>
            <UserJobRequestPage {...props} />
          </React.StrictMode>
        </ToastProvider>
      );
    }
  });

  // ======== ProjectRequestEdit(プロジェクト募集要項編集)  ========
  const jobRequestEditContainers = document.querySelectorAll(
    ".react-user-job-request-edit"
  );
  jobRequestEditContainers.forEach((container) => {
    if (container) {
      const dataset = container.dataset;
      const userJobRequest = dataset.userJobRequest
        ? JSON.parse(dataset.userJobRequest)
        : {};
      const flashMessage = dataset.flashMessage
        ? JSON.parse(dataset.flashMessage)
        : null;

      const props = {
        userJobRequest,
        flashMessage,
        csrfToken: dataset.csrfToken,
        formAction: dataset.formAction,
      };

      const root = createRoot(container);
      root.render(
        <React.StrictMode>
          <JobRequestEdit {...props} />
        </React.StrictMode>
      );
    }
  });

  // ======== companu_users(担当者) ========
  const container = document.getElementById('company-users-root');
  if (container) {
    const root = createRoot(container);
    root.render(
      <BrowserRouter>
        <CompanyUsers />
      </BrowserRouter>
    );
  }

  // ======== AppRouter（ルーティング全体） ========
  const appRouterContainers = document.querySelectorAll(".react-app-router");
  appRouterContainers.forEach((container) => {
    if (container) {
      const dataset = container.dataset;
      const flashMessage = dataset.flashMessage
        ? JSON.parse(dataset.flashMessage)
        : null;
      const currentUser = dataset.currentUser
        ? JSON.parse(dataset.currentUser)
        : null;

      const props = {
        flashMessage,
        currentUser,
        csrfToken: dataset.csrfToken,
      };

      const appRoot = createRoot(container);
      appRoot.render(
        <ToastProvider>
          <React.StrictMode>
            <AppRouter {...props} />
          </React.StrictMode>
        </ToastProvider>
      );
    }
  });

  // ======== CompanyMypage ========
  const mypageRootElement = document.getElementById("mypage-root");
  if (mypageRootElement) {
    const dataset = mypageRootElement.dataset;
    const flashMessage = dataset.flashMessage
      ? JSON.parse(dataset.flashMessage)
      : null;
    const currentUser = dataset.currentUser
      ? JSON.parse(dataset.currentUser)
      : null;

    const props = {
      flashMessage,
      currentUser,
      csrfToken: dataset.csrfToken,
    };

    const root = createRoot(mypageRootElement);
    root.render(
      <ToastProvider>
        <React.StrictMode>
          <AppRouter {...props} />
        </React.StrictMode>
      </ToastProvider>
    );
  }

  // ======== Unread(未読プロジェクト・求人プロジェクト) ========
  const unreadContainers = document.querySelectorAll(".react-unread");

  unreadContainers.forEach((container) => {
    const dataset = container.dataset;

    const props = {
      acceptingProjects: dataset.acceptingProjects === "true",
      acceptingJobs: dataset.acceptingJobs === "true",
      projectIndexUrl: dataset.projectIndexUrl,
      jobIndexUrl: dataset.jobIndexUrl,
      unreadProjects: JSON.parse(dataset.projects || "[]"),
      unreadJobs: JSON.parse(dataset.jobs || "[]"),
      projectUnreadCount: Number(dataset.projectUnreadCount || 0),
      jobUnreadCount: Number(dataset.jobUnreadCount || 0),
    };

    props.totalUnreadCount = props.projectUnreadCount + props.jobUnreadCount;

    const root = createRoot(container);
    root.render(
      <BrowserRouter>
        <Unread {...props} />
      </BrowserRouter>
    );
  });
});
